<template>
    <div class="employees mb-5">
		<router-view name="presentAssignment"></router-view>
		<v-layout wrap justify-space-between>
			<v-flex xs5 md3 sm3 d-flex >
				<v-select
					class="select-core"
					height="37"
					hide-details
					label="Áreas"
					outline
					single-line
					:items="groups"
					item-value="id"
					item-text="name"
					:menu-props="{ contentClass: 'type-select-content' }"
					v-model="filterArea"
					@input="filterRows($event, 'groupId')"
				></v-select>
			</v-flex>
			<button-clear
				:value="value"
				@click="clearFilter"/>
			<v-flex xs12 my-4>
				<v-divider></v-divider>
			</v-flex>
			<v-flex xs12>
				<employees-list
					class="employeList"
					:rows="employees"
					:checkAll="checkAll"
					:disabled-assign="disabledAssign"
					:total-items-visible="employees.length"
					:total-items="totalItems"
					:last-page="lastPage"
					:current-page="currentPage"
					:flag-num="flagNum"
					:filter-area="filterArea"
					:data-selected="dataSelected"
					@click-icon="clickIcon"
					@on-page="changePage"
					@on-search-event="onSearchEvent"
					@open-area="openAssignArea"
					@open-modal="openModalEmployee"
					@row-is-selected="rowIsSelected"
					@selected-all="selectedAll"
					@changeSort="changeSort"
					@load-employees-data="loadEmployeesData"
				></employees-list>
			</v-flex>
		</v-layout>
		<open-modal
			:color="color"
			:create="disabledCreate"
			:dialog="openDialog"
			:mostrar-btn="openButton"
			:title="title"
			@close-modal="closeModal"
			@create-employee="createEmployee"
		>
			<div v-if="action === 'create' || action === 'edit'" class="employee-table">
				<h2
					class="title-modal"
					:style="`color:${$appColors.primary}`"
				>
					{{titleModal}}
				</h2>
				<v-layout class="mt-4" d-flex row wrap justify-space-between>
					<v-flex xs2>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Nombre
						</label>
						<v-text-field
							label="Nombre"
							solo
							hide-details
							class="input-text"
							v-model="model.name"
						></v-text-field>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.name.$invalid"
						>
							El nombre es requerida
						</span>
					</v-flex>
					<v-flex xs2>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Apellidos
						</label>
						<v-text-field
							label="Apellidos"
							solo
							hide-details
							class="input-text"
							v-model="model.lastName"
						></v-text-field>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="!$v.model.lastName.required"
						>
							El apellido es requerido
						</span>
					</v-flex>
					<v-flex xs1>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Sexo
						</label>
						<v-select
							height="37"
							label="Sexo"
							solo
							class="type-select"
							:items="gender"
							:menu-props="{ contentClass: 'type-select-content' }"
							item-value="id"
							item-text="name"
							v-model="model.gender"
							hide-details
						></v-select>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.gender.$invalid"
						>
							El sexo es requerido
						</span>
					</v-flex>
					<v-flex xs1>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Fecha de Nacimiento
						</label>
						<app-date-flat
							v-if="model.dateBirth"
							class="input-text"
							date-format="Y-m-d"
							v-model="model.dateBirth"
							:default-date="model.dateBirth"
							:enable-time="false"
							:blockFutureDates="true"
							:style="`border-radius:4px; color: ${$appColors.info} !important`"
							@input="changeDate({ model: 'dateBirth', value: $event })"
						></app-date-flat>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.dateBirth.$invalid"
						>
							Este campo es requerido
						</span>
					</v-flex>
					<v-flex xs1>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Edad
						</label>
						<v-tooltip top>
							<v-text-field
							class="input-text"
							:disabled="true"
							label="Edad"
							solo
							v-model="model.years"
							slot="activator"
							></v-text-field>
							<span>Campo calculado en base a la fecha de nacimiento</span>
						</v-tooltip>
					</v-flex>
					<v-flex xs1>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Teléfono
						</label>
						<v-text-field
							class="input-text"
							label="Teléfono"
							solo
							v-model="model.phoneNumber"
						></v-text-field>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.phoneNumber.$invalid"
						>
							Este campo es requerido
						</span>
					</v-flex>
					<v-flex xs1>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Fecha de ingreso
						</label>
						<app-date-flat
							v-if="model.entryDate"
							class="input-text"
							date-format="Y-m-d"
							v-model="model.entryDate"
							:default-date="model.entryDate"
							:enable-time="false"
							:blockFutureDates="true"
							:style="`border-radius:4px; color: ${$appColors.info} !important`"
							@input="changeDate({ model: 'entryDate', value: $event })"
						></app-date-flat>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.entryDate.$invalid"
						>
							Este campo es requerido
						</span>
					</v-flex>
					<v-flex xs1>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Años de servicio
						</label>
						<v-tooltip top>
							<v-text-field
								class="input-text"
								label="años de servicio"
								solo
								v-model="model.workingYears"
								type="number"
								:disabled="true"
								slot="activator"
							></v-text-field>
							<span>Campo calculado en base a la fecha de ingreso</span>
						</v-tooltip>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.workingYears.$invalid"
						>
							Este campo es requerido
						</span>
					</v-flex>
				</v-layout>
				<v-layout class="mt-4" d-flex row wrap justify-space-between>
					<v-flex md2>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Tipo de Documento
						</label>
						<v-select
							height="37"
							label="Tipo de Documento"
							solo
							class="type-select"
							v-model="model.typeDocument"
							item-value="id"
							item-text="name"
							:menu-props="{ contentClass: 'type-select-content' }"
							hide-details
							:items="typeDocuments"
							@input="setData($event)"
						></v-select>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.typeDocument.$invalid"
						>
							El tipo de documento es requerido
						</span>
					</v-flex>
					<v-flex xs3 md2>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Nro de Documento
						</label>
						<v-text-field
							class="input-text"
							label="Nro de Documento"
							solo
							v-model="model.documentNumber"
						></v-text-field>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="!$v.model.documentNumber.required"
						>
							El número de documento es requerido
						</span>
						<span
							class="form-group__message"
							v-if="!$v.model.documentNumber.minLength || !$v.model.documentNumber.maxLength"
						>
							{{ documentMessage }}
						</span>
					</v-flex>
					<v-flex xs3 md3>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Correo
						</label>
						<v-text-field
							solo
							class="input-text"
							label="Correo"
							v-model="model.email"
						></v-text-field>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="!$v.model.email.required"
						>
							El email es requerido
						</span>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="!$v.model.email.email"
						>
							El email debe ser válido
						</span>
					</v-flex>
					<v-flex md2>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Áreas
						</label>
						<v-select
							height="37"
							label="Áreas"
							solo
							class="type-select"
							v-model="model.group"
							item-value="id"
							item-text="name"
							:menu-props="{ contentClass: 'type-select-content' }"
							:items="groups"
							return-object
						></v-select>
						<!-- <span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.group.$invalid"
						>
							El área es requerida
						</span> -->
					</v-flex>
					<v-flex xs2 mb2>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Puesto
						</label>
						<v-select
							height="37"
							label="Puesto"
							solo
							class="type-select"
							v-model="model.job"
							item-value="id"
							item-text="name"
							:menu-props="{ contentClass: 'type-select-content' }"
							hide-details
							:items="jobs"
							return-object
						></v-select>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.job.$invalid"
						>
							El Puesto es requerido
						</span>
					</v-flex>
				</v-layout>
				<v-layout d-flex row wrap justify-space-between>
					<v-flex xs2 mb2>
						<label
							class="name"
							:style="`color:${$appColors.info}`"
						>
							Agencia
						</label>
						<v-select
							height="37"
							label="Agencia"
							solo
							class="type-select"
							autocomplete
							v-model="model.subsidiary"
							item-value="id"
							item-text="name"
							:items="subsidiaries"
							:menu-props="{ contentClass: 'type-select-content' }"
							hide-details
							return-object
						></v-select>
						<span
							class="form-group__message"
							:style="`color:${$appColors.error}`"
							v-if="$v.model.subsidiary.$invalid"
						>
							La Agencia es requerida
						</span>
					</v-flex>
				</v-layout>
			</div>
			<div class="table-area" v-if="action === 'assign'">
				<h2 class="title-modal" :style="`color:${$appColors.primary}`">Asignar Áreas</h2>
				<assign-area
					class="mt-3"
					:rows="groups"
					:columns="columnsModal"
					@change-radio="changeRadio"
					viewRadio>
					<template slot="rows" slot-scope="props">
						<td>{{ props.row.name }}</td>
						<td>{{ props.row.totalEmployees }}</td>
					</template>
				</assign-area>
			</div>
			<div v-if="action === 'delete'">
				<h3 class="title-delete">{{`¿ Desea eliminar a ${employeeDelete.name} de la lista de empleados ?`}}</h3>
			</div>
		</open-modal>
	</div>
</template>

<script>
import employeesList from '@/components/configuration/employees-list';
import appDateFlat from '@/components/shared/app-date-flat';
import buttonClear from '@/components/configuration/button-clear';
import { required, email, maxLength, minLength } from 'vuelidate/lib/validators';
import openModal from '@/components/configuration/open-modal';
import assignArea from '@/components/configuration/assign-area';
import PButton from '@/modules/shared/components/ui/p-button';
import { format } from 'date-fns';
import helper from '@/shared/helper';

const { calculateYears } = helper;

function created() {
	this.loadData();
	this.loadEmployees();
}

function closeModal(val) {
	this.openDialog = val;
	this.selectArea = null;
	this.idEdit = null;
	this.clearModal();
	this.action = null;
	this.color = 'primary';
}

async function listEmployees() {
	try {
		({ data: this.employees } = await this.$httpPraktiko.get('employee'));
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		}
	}
}

async function loadJobs() {
	try {
		if (this.model.group) {
			const groupId = this.model.group.id;
			const { data: response } = await this.$httpPraktiko.get(`groups/jobs?areaIds=${groupId}`);
			this.jobs = response;
			if (this.model.jobId) {
				this.model.job = this.jobs.find(job => job.id === this.model.jobId);
			}
		}
	} catch (error) {
		this.showGenericError();
	}
}

function openAssignArea() {
	this.openDialog = true;
	this.title = 'Asignar';
	this.action = 'assign';
}

function disabledCreate() {
	let validate = false;
	if (this.action === 'create' || this.action === 'edit') {
		validate = this.$v.model.$invalid;
	} else if (this.action === 'assign') {
		validate = !this.selectArea;
	}
	return validate;
}

async function loadData() {
	const requests = [
		this.$httpPraktiko.get('groups'),
		this.$httpPraktiko.get('type-documents'),
		this.$httpPraktiko.get('subsidiaries'),
	];
	try {
		[{ data: this.groups }, { data: this.typeDocuments }, { data: this.subsidiaries }]
			= await Promise.all(requests);
		this.groups = this.groups.map((g) => {
			const newGroup = { ...g };
			newGroup.isSelected = false;
			return newGroup;
		});
	} catch (error) {
		this.showGenericError();
	}
}

function createEmployee() {
	if (this.action === 'create' || this.action === 'edit') {
		this.selectCreateEmployee();
	} else if (this.action === 'assign') {
		this.selectAssignArea();
	} else if (this.action === 'delete') {
		this.deleteEmployee();
	}
}

function validations() {
	const documentValidations = { required };
	if (this.personValidations) {
		if (this.personValidations.maxLength) {
			documentValidations.maxLength = maxLength(this.maxDocument);
		}
		if (this.personValidations.minLength) {
			documentValidations.minLength = minLength(this.minDocument);
		}
	}
	return {
		model: {
			documentNumber: documentValidations,
			email: { email, required },
			gender: { required },
			lastName: { required },
			name: { required },
			typeDocument: { required },
			workingYears: { required },
			// group: { required },
			entryDate: { required },
			dateBirth: { required },
			job: { required },
			subsidiary: { required },
			phoneNumber: { required },
		},
	};
}

function rowIsSelected(value) {
	if (value.isSelected) {
		this.dataSelected.push(value);
	} else {
		const index = this.dataSelected.findIndex(d => d.id === value.id);
		if (index > -1) {
			this.dataSelected.splice(index, 1);
		}
	}
	this.checkAll = this.employees.every(e => e.isSelected);
}

function selectedAll(value) {
	this.employees = this.employees.map((r) => {
		const newRow = { ...r };
		newRow.isSelected = value;
		return newRow;
	});
	this.checkAll = value;
	this.dataSelected = value ? [...this.employees] : [];
}

function disabledAssign() {
	return !this.dataSelected.length > 0;
}

function changeRadio(value) {
	this.selectArea = value;
}

function openModalEmployee() {
	this.openDialog = true;
	this.title = 'Crear';
	this.titleModal = 'Crear Empleado';
	this.action = 'create';
	this.model.entryDate = format(new Date());
	this.model.workingYears = calculateYears(this.model.entryDate);
	this.model.dateBirth = format(new Date());
	this.model.years = calculateYears(this.model.dateBirth);
}

async function selectCreateEmployee() {
	const method = this.idEdit ? 'patch' : 'post';
	const url = this.idEdit ? `employee/${this.idEdit}` : 'employee';
	const message = this.idEdit ? 'editó' : 'creó';
	this.model.years = Number(this.model.years);
	// this.model.workingYears = Number(this.model.workingYears);
	this.model.groupId = this.model.group ? this.model.group.id : null;
	this.model.jobId = this.model.job ? this.model.job.id : null;
	this.model.subsidiaryId = this.model.subsidiary ? this.model.subsidiary.id : null;
	this.model.dateBirth = format(new Date(this.model.dateBirth), 'YYYY-MM-DD');
	try {
		await this.$httpPraktiko[method](url, this.model);
		this.showNotification(`Se ${message} correctamente`);
		this.closeModal();
		this.loadEmployees();
		this.open = !this.open;
	} catch (error) {
		if (error.data.statusCode === 400) {
			if (error.data.message === 'ACL_REGISTER_USER_ERROR') {
				this.showGenericError('El correo ya esta registrado');
			}
			if (error.data.message === 'EMPLOYEE_ALREADY_EXIST') {
				this.showGenericError('El empleado ya se encuentra registrado');
			}
		} else {
			this.showGenericError();
		}
	}
}

async function selectAssignArea() {
	const body = { ids: this.dataSelected.map(d => d.id) };
	try {
		await this.$httpPraktiko.patch(`employee/assign/${this.selectArea}`, body);
		this.showNotification('La acción se realizó correctamente');
		this.closeModal(false);
		this.loadEmployees();
		this.dataSelected = [];
		this.checkAll = false;
		this.open = !this.open;
	} catch (error) {
		this.showGenericError();
	}
}

function filterRows(filter, value) {
	this.flagNum += 1;
	this.sortField = null;
	this.sortDirection = null;
	this.paramsGroup[value] = filter;
	this.loadEmployees();
}

function changeSort({ fieldName, sortDirection }) {
	this.sortField = fieldName;
	this.sortDirection = sortDirection;
	this.loadEmployees();
}

async function loadEmployees() {
	const params = {
		...this.params,
		sortField: this.sortField ? this.sortField : null,
		sortDirection: this.sortField ? this.sortDirection : null,
		groupId: Object.keys(this.paramsGroup).length > 0
			&& this.paramsGroup.groupId ? this.paramsGroup.groupId : null,
	};
	try {
		const { data: response, headers } = await this.$httpPraktiko.get('employee', { params });
		this.employees = response.results;
		this.lastPage = Number(headers['x-last-page']);
		this.totalItems = Number(headers['x-quantity']);
	} catch (error) {
		this.showGenericError();
	}
}

function loadEmployeesData() {
	this.loadEmployees();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadEmployees();
}

function clearFilter() {
	this.flagNum = 0;
	this.sortField = null;
	this.sortDirection = null;
	this.paramsGroup.groupId = null;
	this.loadEmployees();
	this.filterArea = null;
}

function clearModal() {
	this.model = {
		name: null,
		gender: null,
		documentNumber: null,
		typeDocument: null,
		years: null,
		email: null,
		groupId: null,
		group: null,
		lastName: null,
		workingYears: null,
		phoneNumber: null,
		jobId: null,
		job: null,
		subsidiaryId: null,
		subsidiary: null,
		entryDate: null,
		dateBirth: null,
	};
}
function clickIcon(item) {
	if (item.action === 'edit') {
		this.idEdit = item.row.id;
		this.loadEditEmployee(this.idEdit);
		this.titleModal = 'Editar Empleado';
		this.action = 'edit';
		this.title = 'Editar';
	} else if (item.action === 'presents') {
		const params = { employeeId: item.row.id };
		this.goTo('present-assignment', { params });
	} else if (item.action === 'state') {
		this.changeStatusEmployee(item.row);
	}
	// else {
	// 	this.employeeDelete.name = item.row.name;
	// 	this.employeeDelete.id = item.row.id;
	// 	this.action = 'delete';
	// 	this.title = 'Eliminar';
	// 	this.openDialog = true;
	// 	this.color = 'error';
	// }
}

async function changeStatusEmployee(row) {
	const body = {
		id: row.id,
		email: row.email,
		activation: row.status,
	};
	try {
		await this.$httpPraktiko.patch('employee/change-activation', body);
		this.loadEmployees();
	} catch (error) {
		this.showGenericError();
	}
}

function changeDate({ model, value }) {
	this.model[model] = value;
	if (model === 'dateBirth') {
		this.model.years = calculateYears(format(this.model[model], 'YYYY-MM-DD'), true);
	} else {
		this.model.workingYears = calculateYears(format(this.model[model], 'YYYY-MM-DD'));
	}
}

async function loadEditEmployee(id) {
	try {
		const { data: response } = await this.$httpPraktiko.get(`employee/${id}/detail`);
		this.model.name = response.name;
		this.model.gender = response.gender;
		this.model.lastName = response.lastName;
		this.model.phoneNumber = response.phoneNumber;
		this.model.typeDocument = response.typeDocument;
		this.model.email = response.email;
		this.model.groupId = response.groupId;
		this.model.documentNumber = response.documentNumber;
		// this.model.workingYears = response.workingYears;
		this.model.dateBirth = response.dateBirth
			? format(response.dateBirth, 'YYYY-MM-DD') : format(new Date(), 'YYYY-MM-DD');
		this.model.years = response.dateBirth ?
			calculateYears(response.dateBirth, true) : response.years;
		this.model.entryDate = response.entryDate
			? format(response.entryDate, 'YYYY-MM-DD') : format(new Date(), 'YYYY-MM-DD');
		this.model.workingYears = response.entryDate
			? calculateYears(response.entryDate) : response.workingYears;
		this.model.jobId = response.jobId;
		this.model.subsidiaryId = response.subsidiaryId;
		this.model.group = this.groups.find(group => group.id === response.groupId);
		this.model.subsidiary =
			this.subsidiaries.find(subsidiary => subsidiary.id === response.subsidiaryId);
		this.open = true;
		this.openDialog = true;
	} catch (error) {
		this.showGenericError();
	}
}

async function deleteEmployee() {
	try {
		await this.$httpPraktiko.delete(`employee/${this.employeeDelete.id}`);
		this.showNotification('Se eliminó correctamente');
		this.openDialog = false;
		this.loadEmployees();
	} catch (error) {
		if (error.data.statusCode) {
			if (error.data.message === 'EMPLOYEE_TOOL_EXIST') {
				this.showGenericError('El empleado esta asignado a un diagnóstico');
			}
		} else {
			this.showGenericError();
		}
	}
}

function setData(value) {
	this.personType = this.typeDocuments.find(p => p.id === value) || {};
}

function personType(value) {
	this.personValidations = value && value.configuration ? value.configuration.validations :
		value.configuration;
	if (this.personValidations) {
		this.maxDocument = this.personValidations.maxLength || 0;
		this.minDocument = this.personValidations.minLength || 0;
		if (this.maxDocument && this.minDocument) {
			if (this.maxDocument === this.minDocument) {
				this.documentMessage = `Es necesario ingresar ${this.minDocument} dígitos`;
			} else {
				this.documentMessage = `Es necesario ingresar entre ${this.minDocument} y ${this.maxDocument} dígitos`;
			}
		} else if (this.minDocument) {
			this.documentMessage = `Ingrese un mínimo de ${this.minDocument} dígitos`;
		} else if (this.maxDocument) {
			this.documentMessage = `Ingrese un máximo de ${this.maxDocument} dígitos`;
		} else {
			this.documentMessage = '';
		}
	} else {
		this.documentMessage = '';
	}
}

function onSearchEvent(search) {
	this.params.search = search.trim() || null;
	this.changePage(1);
}

function data() {
	return {
		flagNum: 0,
		employees: [],
		currentPage: 1,
		totalItems: 0,
		openButton: false,
		headers: [
			{ text: 'Áreas', value: 'area' },
			{ text: 'Cantidad de Empleados', value: 'quantity' },
		],
		titleArea: 'Asignar',
		title: 'Crear',
		create: false,
		openDialog: false,
		lastPage: 0,
		value: 'Limpiar',
		columns: [
			{ id: 1, name: 'NOMBRE DE EMPLEADO', value: 'name', visible: true, checked: true },
			{ id: 2, name: 'SEXO', value: 'gender', visible: true, checked: true },
			{ id: 3, name: 'EDAD', value: 'year', visible: true, checked: true },
			{ id: 4, name: 'TELÉFONO', value: 'phoneNumber', visible: true, checked: true },
			{ id: 4, name: 'NRO DE DOC', value: 'numDocument', visible: true, checked: true },
			{ id: 5, name: 'CORREO', value: 'email', visible: true, checked: true },
			{ id: 6, name: 'ÁREA', value: 'area', visible: true, checked: true },
			{ id: 7, name: 'ACCIONES', visible: true, checked: true },
		],
		gender: [
			{ id: 1, name: 'Masculino' },
			{ id: 2, name: 'Femenino' },
		],
		typeDocuments: [],
		model: {
			name: null,
			gender: null,
			documentNumber: null,
			typeDocument: null,
			years: null,
			email: null,
			group: null,
			groupId: null,
			job: null,
			jobId: null,
			lastName: null,
			workingYears: null,
			phoneNumber: null,
			subsidiaryId: null,
			subsidiary: null,
			entryDate: null,
			dateBirth: null,
		},
		groups: [],
		subsidiaries: [],
		dataSelected: [],
		checkAll: false,
		selectArea: null,
		filterArea: null,
		paramsGroup: {},
		columnsModal: [
			{ id: 1, name: 'Áreas', col: 2 },
			{ id: 2, name: 'Cantidad de Empleados', col: 1 },
		],
		idEdit: null,
		employeeDelete: {},
		titleModal: 'Crear Empleado',
		action: null,
		color: 'primary',
		personType: {},
		personValidations: null,
		maxDocument: 0,
		minDocument: 0,
		documentMessage: '',
		masterEmployes: [],
		jobs: [],
		sortField: null,
		sortDirection: null,
	};
}

export default {
	name: 'employees',
	created,
	components: {
		employeesList,
		appDateFlat,
		buttonClear,
		openModal,
		assignArea,
		PButton,
	},
	computed: {
		disabledCreate,
		disabledAssign,
	},
	data,
	methods: {
		changePage,
		changeRadio,
		closeModal,
		loadJobs,
		createEmployee,
		clearFilter,
		clearModal,
		clickIcon,
		deleteEmployee,
		filterRows,
		listEmployees,
		loadData,
		loadEmployees,
		changeSort,
		loadEditEmployee,
		changeStatusEmployee,
		onSearchEvent,
		openModalEmployee,
		openAssignArea,
		rowIsSelected,
		selectAssignArea,
		selectCreateEmployee,
		selectedAll,
		setData,
		loadEmployeesData,
		changeDate,
	},
	validations,
	watch: {
		personType,
		'model.group': {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.loadJobs();
				}
			},
			inmediate: true,
		},
	},
};
</script>

<style lang="scss" scoped>
.separator {
	border: 1px solid map-get($colors, border-gray);
}

.border-bottom {
	border: 0.5px solid map-get($colors, placeholder);
	margin-top: 10px;
}

.title-modal {
	font-family: map-get($fonts, bold);
	font-size: 18px;
}

.employee-table {
	.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		background-color: none !important;
	}
}

.title-modal {
	font-size: 11px;
}

.theme--light.v-label {
	color: map-get($colors, placeholder);
}

.v-datatable thead th.column.sortable .v-icon {
	display: none !important;
}

.title-modal {
	font-family: map-get($fonts, bold);
	font-size: 18px;
}

.name {
	font-size: 11px;
}

.theme--light.v-datatable thead th.column.sortable.active {
	color: red !important;
}

.employeList {
	@media (max-width: 950px) {
			width: 700px;
			display: flex;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/employees.vue